module.exports = __webpack_public_path__ + "media/contract/mobile_arrow-a7f043d8.png";